import styled from "@emotion/styled";

export const SectionRoot = styled.section`
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;

export const SectionInner = styled.div`
  width: 100%;
  padding: 44px 24px 52px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;

  @media (max-width: 1024px) {
    padding: 40px 20px 46px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    padding: 32px 16px 40px;
    gap: 14px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  width: 100%;
  color: #d6c6a5;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.3;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 1.35;
  }
`;

export const Form = styled.form`
  width: 100%;
  max-width: 520px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media (max-width: 1024px) {
    max-width: 460px;
    gap: 14px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    gap: 12px;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border: none;
  border-bottom: 1px solid rgba(31, 31, 31, 0.4);
  background: transparent;
  outline: none;
  border-radius: 0;

  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  color: #1f1f1f;
  text-align: center;

  &::placeholder {
    color: rgba(31, 31, 31, 0.45);
  }

  &:focus {
    border-bottom-color: #1f1f1f;
  }

  @media (max-width: 1024px) {
    height: 46px;
    font-size: 17px;
  }

  @media (max-width: 768px) {
    height: 42px;
    font-size: 16px;
  }
`;

export const SubmitButton = styled.button`
  min-width: 168px;
  height: 48px;
  padding: 0 24px;
  border: 1px solid rgba(31, 31, 31, 0.18);
  background: transparent;
  cursor: pointer;

  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: #1f1f1f;

  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #1f1f1f;
    color: #ffffff;
    border-color: #1f1f1f;
  }

  @media (max-width: 1024px) {
    min-width: 160px;
    height: 46px;
    font-size: 17px;
    padding: 0 22px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    height: 44px;
    font-size: 16px;
    padding: 0 18px;
  }
`;
